import React, { useState } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import VendorForm from './VendorForm';

const VendorModal = ({ 
  show, 
  onHide, 
  vendor = null, 
  onSave, 
  title 
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (formData) => {
    try {
      setIsLoading(true);
      setError('');
      await onSave(formData);
      onHide(); // Close modal on success
    } catch (err) {
      console.error('Error saving vendor:', err);
      const errorMsg = err.response?.data?.error || 'Failed to save vendor';
      setError(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || (vendor ? 'Edit Vendor' : 'Add New Vendor')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}
        <VendorForm
          vendor={vendor}
          onSubmit={handleSubmit}
          onCancel={handleClose}
          isLoading={isLoading}
        />
      </Modal.Body>
    </Modal>
  );
};

export default VendorModal;
